import { render, staticRenderFns } from "./customFieldModal.vue?vue&type=template&id=633b4096&scoped=true"
import script from "./customFieldModal.vue?vue&type=script&lang=js"
export * from "./customFieldModal.vue?vue&type=script&lang=js"
import style0 from "./customFieldModal.vue?vue&type=style&index=0&id=633b4096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b4096",
  null
  
)

export default component.exports